export const providersConstants = {
  UPDATE_PROVIDER: '[Providers] Update',
  REMOVE_PROVIDER: '[Providers] Remove',
  LOADING_PROVIDERS: '[Providers] Loading',
  LOADING_PROVIDERS_ERROR: '[Providers] Loading error',
  PROVIDER_AJAX_CALL: '[Providers] Ajax call',
  PROVIDER_AJAX_SUCCESS: '[Providers] Ajax success',
  PROVIDER_AJAX_FAILURE: '[Providers] Ajax error'
}